/**
 * 获取当前相对尺寸
 * 设计稿导出尺寸 1920
 * @param {number} number
 */
export const getRelativelySize = (size) => {
    return (document.documentElement.clientWidth / 1920) * size
}
